import z, { object, string } from "zod"
import { PUBLIC, PRIVATE, PROTECTED, CLOSE_FRIENDS } from "constants/index"

export const wishListSchema = object({
  name: string().min(1, "Wishlist name is required"),
  privacy: z.enum([PUBLIC, PRIVATE, PROTECTED, CLOSE_FRIENDS])
})
